/**
 * @generated SignedSource<<355bd55deb0646cc812a2564455efd22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutProgressReview_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"CheckoutAddressReview_address">;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutStepLink_buyer">;
  readonly " $fragmentType": "CheckoutProgressReview_buyer";
};
export type CheckoutProgressReview_buyer$key = {
  readonly " $data"?: CheckoutProgressReview_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutProgressReview_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "partialAddressCheckoutEligibility"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutProgressReview_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutStepLink_buyer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "partialAddressCheckoutEligibility",
          "variableName": "partialAddressCheckoutEligibility"
        }
      ],
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CheckoutAddressReview_address"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e09ccf97a63992643fb374c6542f36e1";

export default node;
